import { hexToRgb, hslToRgb } from '@mui/material';
import { Rive, useViewModelInstanceColor } from '@rive-app/react-canvas';
import { useEffect } from 'react';

export interface RiveAnimationThemingProps {
  rive: Rive | null;
  children: React.ReactNode;
  color: string;
}

export const RiveAnimationTheme = ({
  children,
  rive,
  color,
}: RiveAnimationThemingProps) => {
  const { setRgba, value } = useViewModelInstanceColor(
    'Color property',
    rive?.viewModelInstance,
  );

  useEffect(() => {
    if (!rive || !setRgba || !color || value !== null) {
      return;
    }

    let apply = color;
    const isHex = color.startsWith('#');
    const isHsl = color.startsWith('hsl');

    if (isHex) {
      apply = hexToRgb(color);
    }

    if (isHsl) {
      apply = hslToRgb(color);
    }

    const [red, green, blue, alpha] = apply.match(/\d+/g)?.map(Number) ?? [];

    setRgba(red ?? 0, green ?? 0, blue ?? 0, (alpha ?? 1) * 255);
  }, [rive, color, setRgba, value]);

  return <>{children}</>;
};
